<div class="w-p-max-100 flex flex-col flex-1-0-100" data-cy="fx-rate-report-settings">
  <!--  <div class="flex flex-row" fxLayoutAlign="space-between center" fxFlex="1 0 auto">-->
  <div class="m-b-5">
    <h3 class="component-heading">
      {{title}}
    </h3>
  </div>
  <form class="p-t-5 flex flex-col full-grow-no-shrink-no-basis" (keydown.enter)="$event.preventDefault()"
        [formGroup]="inputForm" data-cy="fx-rate-report-settings-form">
    <div>
      <mat-form-field appearance="outline" class="flex-0-0-100">
        <mat-label>Report Name</mat-label>
        <input matInput formControlName="reportTitle" placeholder="Report Name"
               data-cy="fx-rate-input-report-title"/>
      </mat-form-field>
    </div>

    <div>
      <mat-form-field appearance="outline" class="flex-0-0-100">
        <mat-label>Rate Type</mat-label>
        <input matInput formControlName="rateType" placeholder="Rate Type"
               data-cy="fx-rate-input-rate-type"/>
      </mat-form-field>
    </div>

    <div *ngIf="this.reportModel.rateType === types.TaxYearRate" class="flex flex-row">
      <mat-form-field appearance="outline" class="orbitax-date-picker flex-0-0-180px">
        <mat-label>Tax Year End*</mat-label>
        <input matInput formControlName="taxYearEnd" [matDatepicker]="picker1" placeholder="Tax Year End"
               particleAnalytics
               analyticsCategory="date-time-cell"
               analyticsAction="date-picker"
               data-cy="fx-rate-input-tax-year-end">
        <mat-datepicker-toggle matSuffix [for]="picker1" data-cy="fx-rate-datepicker-tax-year-end"></mat-datepicker-toggle>
        <mat-datepicker #picker1></mat-datepicker>
        <mat-error *ngIf="inputFormError.taxYearEnd?.required">
          Tax Year End is required!
        </mat-error>
      </mat-form-field>

    </div>
    <div class="flex flex-col" *ngIf="this.reportModel.rateType === types.PeriodRate">
      <div class="flex flex-row">
        <mat-form-field appearance="outline" class="orbitax-date-picker flex-0-0-180px">
          <mat-label>Start Date*</mat-label>
          <input matInput formControlName="startDate" [matDatepicker]="picker1" placeholder="Start Date"
                 particleAnalytics
                 analyticsCategory="date-time-cell"
                 analyticsAction="date-picker"
                 data-cy="fx-rate-input-start-date">
          <mat-datepicker-toggle matSuffix [for]="picker1" data-cy="fx-rate-datepicker-start-date"></mat-datepicker-toggle>
          <mat-datepicker #picker1></mat-datepicker>
          <mat-error *ngIf="inputFormError.startDate?.required">
            Start Date is required!
          </mat-error>
        </mat-form-field>
      </div>
      <div class="flex flex-row">
        <mat-form-field appearance="outline" class="orbitax-date-picker flex-0-0-180px">
          <mat-label>End Date*</mat-label>
          <input matInput formControlName="endDate" [matDatepicker]="picker2" placeholder="End Date"
                 particleAnalytics
                 analyticsCategory="date-time-cell"
                 analyticsAction="date-picker"
                 data-cy="fx-rate-input-end-date">
          <mat-datepicker-toggle matSuffix [for]="picker2" data-cy="fx-rate-datepicker-end-date"></mat-datepicker-toggle>
          <mat-datepicker #picker2></mat-datepicker>
          <mat-error *ngIf="inputFormError.endDate?.required">
            End Date is required!
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="spot-rate-date-picker-container" *ngIf="this.reportModel.rateType === types.SpotRate"
         data-cy="fx-rate-spot-rate-dates">

      <a (click)="addDate()" particleAnalytics class="m-b-10 flex flex-row" analyticsCategory=""
         analyticsAction="add-item" data-cy="fx-rate-btn-add-spot-rate">
        <i class="fa-solid fa-plus"></i> Add Spot Rate</a>
      <div formArrayName="spotDates" class="m-b-5"
           *ngFor="let item of inputForm.controls['spotDates'].controls; let i = index; let j= index;"
           [attr.data-cy]="'fx-rate-spot-date-row-' + i">
        <div [formGroup]="item" class="w-p-100 flex flex-row">
          <mat-form-field appearance="outline" class="orbitax-date-picker flex-0-0-180px" style="margin-bottom: 10px!important">
            <mat-label>Date*</mat-label>
            <input matInput formControlName="date" [matDatepicker]="picker3" placeholder="Date"
                   [max]="today"
                   particleAnalytics
                   analyticsCategory="date-time-cell"
                   analyticsAction="date-picker"
                   [attr.data-cy]="'fx-rate-input-spot-date-' + i">
            <mat-datepicker-toggle matSuffix [for]="picker3"
                                   [attr.data-cy]="'fx-rate-datepicker-spot-date-' + i"></mat-datepicker-toggle>
            <mat-datepicker #picker3></mat-datepicker>
            <mat-error *ngIf="inputFormError.spotDates?.required">
              Date is required!
            </mat-error>
          </mat-form-field>
          <button *ngIf="this.inputForm.controls['spotDates'].length > 1" mat-icon-button class="remove-btn"
                  type="button"
                  (click)="deleteDate(j)"
                  particleAnalytics
                  analyticsCategory=""
                  analyticsAction="delete-item"
                  [attr.data-cy]="'fx-rate-btn-delete-spot-date-' + i">
            <i class="far fa-trash"></i>
          </button>
        </div>

        <!-- Chosen name: {{ orderForm.controls.items.controls[i].controls.name.value }}-->
      </div>


    </div>

    <div *ngIf="reportModel.rateType != types.SpotRate">
      <mat-form-field appearance="outline" class="flex-0-0-100">
        <mat-label>Summary Rate View</mat-label>
        <mat-select formControlName="summaryRateView" (selectionChange)="onSectionSelectionChange($event)"
                    data-cy="fx-rate-dropdown-summary-rate-view">
          <mat-option *ngFor="let summaryRateView of summaryRateViews"
                      [value]="summaryRateView"
                      [attr.data-cy]="'fx-rate-option-summary-' + summaryRateView">
            {{summaryRateView}}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="inputFormError.summaryRateView.required">
          Summary Rate View is required!
        </mat-error>
      </mat-form-field>
    </div>

    <div *ngIf="reportModel.rateType != types.SpotRate">
      <mat-form-field appearance="outline" class="flex-0-0-100">
        <mat-label>Detailed FX Rate View</mat-label>
        <mat-select formControlName="detailsRateView" (selectionChange)="onSectionSelectionChange($event)"
                    data-cy="fx-rate-dropdown-details-rate-view">
          <mat-option *ngFor="let detailsRateView of detailsRateViews"
                      [value]="detailsRateView"
                      [attr.data-cy]="'fx-rate-option-details-' + detailsRateView">
            {{detailsRateView}}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="inputFormError.detailsRateView.required">
          Detailed FX Rate View is required!
        </mat-error>
      </mat-form-field>
    </div>

    <mat-form-field appearance="outline" class="w-p-100" floatLabel="always" floatPlaceholder="always"
                    *ngIf="reportModel.rateType != types.SpotRate && disableRateFormatSelection == false"
                    data-cy="fx-rate-format-options">
      <mat-label>Fx Rate Format</mat-label>
      <input analyticsAction="entity-scope-input" analyticsCategory="choice-filter-modal-item-editor" matInput
             particleAnalytics
             placeholder="Input"
             style="display: none">

      <ng-container formArrayName="permissionsArray">
        <ul class="checkbox-container">
          <li *ngFor="let fxRateFormatOption of fxRateFormatOptions">
            <mat-checkbox [checked]="fxRateFormatOption.isChecked"
                          (change)="updateFxRateFormats($event, fxRateFormatOption.key)"
                          [attr.data-cy]="'fx-rate-checkbox-' + fxRateFormatOption.key">
              {{fxRateFormatOption.title}}
            </mat-checkbox>
          </li>
        </ul>

      </ng-container>


    </mat-form-field>
  </form>
</div>
